import { watch } from 'vue'

import Clarity from '@microsoft/clarity'

import { useAuthStore } from '@/store/auth'

export const useMsClarity = () => {
  const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID
  const authStore = useAuthStore()

  if (!projectId) {
    return
  }

  Clarity.init(projectId)

  watch(
    () => authStore.user,
    (newUser) => {
      if (newUser?.employee_id) {
        Clarity.identify(newUser.employee_id)
      }
    },
    { immediate: true },
  )
}
